import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';

import { ContractDialogComponent } from '../contract-dialog/contract-dialog.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { ContractModificationDialogComponent } from '../contract-modification-dialog/contract-modification-dialog.component';
import { selectAllContracts, selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Car } from 'src/app/public/car/models/car.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { TransactionRole } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource, GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { ContractStatus, ContractModificationType, ContractModificationStatus, ContractLineStatus } from '../../constants/dealer-basic-data';
import { ContractLine } from '../../models/contract-line.model';
import { ContractModification } from '../../models/contract-modification.model';
import { Contract } from '../../models/contract.model';

@Component({
    selector: 'app-contracts',
    templateUrl: './contracts.component.html',
    styleUrls: ['./contracts.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule,
        NgIf, NgFor, AsyncPipe, RouterLink]
})
export class ContractsComponent implements OnInit{

  // @Input() contracts: Contract [] = [];
  @Input() cars: Car [] = [];
  // @Input() fetchingResults: boolean = false;
  // @Input() newContractProviderId: string = '';
  // @Input() newContractCount: number = 0;

  // @Input() potentialProviders: string [] = [];

  // @Input() objectSource: ObjectSource = ObjectSource.DEALER;

  @Input() objectSource: ObjectSource = ObjectSource.DEALER;
  @Input() transactionRole: TransactionRole = TransactionRole.CUSTOMER;
  @Input() dealerId: string = "";
  @Input() enableNew: boolean = false;

  contracts$: Observable<Contract[]>;
  contracts: Contract[] = [];
  

  selectedProviderId = "";

  ContractStatus = ContractStatus;
  ContractModificationType = ContractModificationType;
  ContractModificationStatus = ContractModificationStatus;
  ContractLineStatus = ContractLineStatus;

  showNonActiveModifs: boolean = false;
  showNonActiveLines: boolean = false;

  openNewDialog$:BehaviorSubject<number>;

  currentUserId$ : Observable<string>;
  currentUserId: string = "";

  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

      this.openNewDialog$ = new BehaviorSubject<number>(0);

      this.contracts$ = this.store.select(selectAllContracts(this.objectSource, this.dealerId, this.transactionRole))         
      this.currentUserId$ = this.store.select(selectLoggedInUserDataId);
    }

  ngOnInit(): void {

    this.contracts$ = this.store.select(selectAllContracts(this.objectSource, this.dealerId, this.transactionRole))          
    this.currentUserId$ = this.store.select(selectLoggedInUserDataId);
    
  }

  ngOnChanges(changes: SimpleChanges): void {
   // if(this.newContractCount > 0){
    //  this.openContractDialog(this.newContractProviderId, undefined)
   // }
    
  }

  openContractDialog(providerId: string, contractId: number): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let contract: Contract;
    let objectData: ObjectData = new ObjectData(this.objectSource, providerId, contractId);
    objectData.transactionRole = this.transactionRole

    const dialogRef = this.dialog.open(ContractDialogComponent, {
      data: objectData
    });
    
    /*
    dialogRef.afterClosed().subscribe((result: Contract) => {

      console.log('helloo = '+JSON.stringify(result));
      
      if(result != undefined ){

        //console.log('New contract = '+result.status+ " date = "+result.contractDate+ " car Id = "+JSON.stringify(result));
        if(result.contractId === ''){
          console.log('new');
          this.store.dispatch(DealerActions.contractNewSubmit ( { contract: result, objectSource: this.objectSource }));
          return;
        }

        else{
          console.log('update')
          this.store.dispatch(DealerActions.contractUpdateSubmit ( { contract: result, objectSource: this.objectSource }));          
          return;
        } 
      }  
    });
    */
  }

  openContractModificationDialog(contractId: string, prop?: ContractModification): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let modification: ContractModification;

    if(prop !== undefined){
      modification = JSON.parse(JSON.stringify(prop!));
      console.log('hello 1')
    }else{
      modification = new ContractModification();
      modification.type = ContractModificationType.CAR_ADD
      //modification.carId = carId;
      console.log('hello 2')
    }    
    console.log('cars = '+this.cars.length)
    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(ContractModificationDialogComponent, {
      data: {modification: modification, cars: this.cars}
    });
    
    dialogRef.afterClosed().subscribe((result: {modification: ContractModification, cars: string[]}) => {

      //console.log('helloo = '+JSON.stringify(result));
      //return;
      
      if(result != undefined ){

        //console.log('New contract = '+result.status+ " date = "+result.contractDate+ " car Id = "+JSON.stringify(result));
        if(result.modification.id === -1){
          console.log('new');
          if(result.modification.carId !== ""){
            console.log('helloo 1 = '+JSON.stringify(result.modification));
            this.store.dispatch(DealerActions.contractModificationNewSubmit ( { contractId: contractId, request: result.modification, objectSource: this.objectSource }));
          }
          else{
            result.cars.forEach( carId =>{
              let modif: ContractModification = Object.assign(new ContractModification(), result.modification);
              modif.carId = carId;
              console.log('helloo 2 = '+JSON.stringify(modif));
              this.store.dispatch(DealerActions.contractModificationNewSubmit ( { contractId: contractId, request: modif, objectSource: this.objectSource }));
            });
          }
          return;
        }

        else{
          console.log('update')
          //this.store.dispatch(DealerActions.contractModificationUpdateSubmit ( { contractId: contractId, request: result }));          
          return;
        } 
      }  
    });
  }

  updateContract(contract: Contract){

    this.store.dispatch(DealerActions.contractUpdateSubmit ( { contract: contract, objectSource: this.objectSource }));

  }

  deleteContract(contractId: string){

    this.store.dispatch(DealerActions.contractDeleteSubmit ( { contractId: contractId, objectSource: this.objectSource }));

  }

  proposeContract(contractId: string){

    let request : ContractModification = new ContractModification();
    request.type = ContractModificationType.CONTRACT_PROPOSE;

    this.store.dispatch(DealerActions.contractModificationNewSubmit ( { contractId: contractId, request: request, objectSource: this.objectSource }));

  }

  withdrawContract(contractId: string, modificationId: number){

    this.store.dispatch(DealerActions.contractModificationWithdrawSubmit ( { contractId: contractId, modificationId: modificationId, objectSource: this.objectSource }));

  }

  answerContract(contractId: string, modificationId: number, answer: boolean){

    this.store.dispatch(DealerActions.contractModificationAnwerSubmit ( { contractId: contractId, modificationId: modificationId, accepted: answer, objectSource: this.objectSource }));

  }

  submitContractUpdate(contractId: string, modificationId: number, answer: boolean){

    //this.store.dispatch(DealerActions.contractModificationAnwerSubmit ( { contractId: contractId, modificationId: modificationId, accepted: answer }));

  }

  
  submitCarContractModif(contractId: string, carId: string, type: ContractModificationType){

    let request : ContractModification = new ContractModification();
    request.type = type;
    request.carId = carId;

    this.openContractModificationDialog(contractId, request);

    //this.store.dispatch(DealerActions.contractModificationAnwerSubmit ( { contractId: contractId, modificationId: modificationId, accepted: answer }));

  }

  submitUpdateRequest(contractId: string, answer: boolean){

    let request : ContractModification = new ContractModification();
    request.type = ContractModificationType.CONTRACT_UPDATE;

    this.store.dispatch(DealerActions.contractModificationUpdateSubmit ( { contractId: contractId, request: request, objectSource: this.objectSource }));

  }

  isModificationActive(mod: ContractModification) {
    if (mod.status === ContractModificationStatus.PROPOSED) {
      return true;
    }
    return false;
  }

  isModificationNotActive(mod: ContractModification) {
    if (mod.status === ContractModificationStatus.PROPOSED) {
      return false;
    }
    return true;
  }

  isLineActive(line: ContractLine) {
    if (line.status === ContractLineStatus.CLOSED) {
      return false;
    }
    return true;
  }

  isLineNotActive(line: ContractLine) {
    if (line.status === ContractLineStatus.CLOSED) {
      return true;
    }
    return false;
  }

  getCar(carId: string): Car{
    return this.cars.find(car =>  car.carId == carId )!
  }

  getCarDesc(carId: string): string{
    let car: Car = this.cars.find(car =>  car.carId == carId )!

    return car == undefined ? carId: car.make + " "+ car.model +" "+car.year
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  getCountryByCode(code: string): Country{
    return GeneralBasicData.getCountryByCode(code)!;
  }

}
